module.exports = __webpack_public_path__ + "img/img-4.be097e43.png";